module.exports = __webpack_public_path__ + "img/device_cc300.f1be87d9.jpg";